import MenuBookIcon from "@mui/icons-material/MenuBook";
import SpellcheckOutlinedIcon from "@mui/icons-material/SpellcheckOutlined";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import GamepadOutlinedIcon from "@mui/icons-material/GamepadOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import MovieFilterOutlinedIcon from "@mui/icons-material/MovieFilterOutlined";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";

export const LESSON_TYPE_PLACEHOLDER = {
  value: "",
  label: "Select Lesson Type",
};

export const LESSON_TYPE_OPTIONS = [
  { value: "chapter_text", label: "Lesson"},
  { value: "grammar", label: "Grammar" },
  { value: "reading", label: "Reading" },
  { value: "assignment", label: "Assignment", aliases: ["writing"]},
  { value: "formative_assessment", label: "Assessment"},
  { value: "discussion", label: "Discussion" },
  { value: "game", label: "Game", aliases: ["interactive"] },
  { value: "summative_assessment", label: "Exam"},
  {
    value: "vocabulary-quiz",
    label: "Vocabulary Quiz",
    aliases: ["vocab-quiz", "quiz", "vocabulary_quiz"],
  },
  { value: "vocabulary", label: "Vocabulary" },
  { value: "audio", label: "Audio", aliases: ["podcast"] },
  { value: "video", label: "Video", aliases: ["lecture-video", "multimedia"] },
  { value: "conversation", label: "Conversation", aliases: ["dialog", "discussion"] },
];

export const DEFAULT_LESSON_TYPE = LESSON_TYPE_OPTIONS[0];

export const LESSON_TYPE_SELECT_OPTIONS = [
  LESSON_TYPE_PLACEHOLDER,
  ...LESSON_TYPE_OPTIONS,
];

export const LESSON_TYPE_VISUALS = {
  lesson: { icon: MenuBookIcon, color: "primary" },
  grammar: { icon: SpellcheckOutlinedIcon, color: "secondary" },
  reading: { icon: AutoStoriesIcon, color: "info" },
  assignment: { icon: ArticleOutlinedIcon, color: "warning" },
  discussion: { icon: ArticleOutlinedIcon, color: "default" },
  game: { icon: GamepadOutlinedIcon, color: "warning" },
  exam: { icon: AnalyticsOutlinedIcon, color: "error" },
  "vocabulary-quiz": { icon: ArticleOutlinedIcon, color: "success" },
  vocabulary: { icon: ArticleOutlinedIcon, color: "success" },
  audio: { icon: HeadphonesOutlinedIcon, color: "success" },
  video: { icon: MovieFilterOutlinedIcon, color: "info" },
  conversation: { icon: VolumeUpOutlinedIcon, color: "secondary" },
  default: { icon: ViewSidebarIcon, color: "primary" },
};

export const BLOOMS_TAXONOMY_SKILLS = [
  { value: "identify", label: "Identify" },
  { value: "understand", label: "Understand" },
  { value: "apply", label: "Apply" },
  { value: "analyze", label: "Analyze" },
  { value: "evaluate", label: "Evaluate" },
  { value: "create", label: "Create" },
];

export const DEFAULT_SKILL_TYPE = BLOOMS_TAXONOMY_SKILLS[0]?.value || "";

export const normalizeSkillTypeValue = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  const trimmed = value.trim();

  if (!trimmed) {
    return "";
  }

  const normalized = trimmed.toLowerCase();

  if (normalized === "remember") {
    return "identify";
  }

  return normalized;
};

export const getLessonTypeVisuals = (lessonType) => {
  if (!lessonType) {
    return LESSON_TYPE_VISUALS.default;
  }

  return LESSON_TYPE_VISUALS[lessonType] || LESSON_TYPE_VISUALS.default;
};
